<template>
  <v-container>
    <v-card max-width="560" class="mx-auto">
      <v-card-title class="text-h5 primary white--text pa-3">
        Company Settings
      </v-card-title>
      <v-container>
        <div class="flex flex-col" style="gap: 10px">
          <!-- Logo preview / placeholder -->
          <div class="flex justify-center">
            <v-img
              v-if="logoPreview"
              :src="logoPreview"
              width="200"
              height="200"
              contain
              class="grey lighten-4 rounded"
            />
            <div
              v-else
              class="flex flex-col items-center justify-center grey lighten-3 rounded"
              style="width: 200px; height: 200px;"
            >
              <v-icon size="64" color="grey">
                mdi-image-off
              </v-icon>
              <span class="grey--text mt-2">No logo</span>
            </div>
          </div>

          <v-file-input
            outlined
            dense
            hide-details
            label="Company Logo"
            accept="image/*"
            prepend-icon="mdi-camera"
            :loading="gettingConfig"
            @change="onLogoChange"
          />

          <v-text-field
            outlined
            dense
            hide-details
            label="Company Name"
            :placeholder="config.companyName ? '' : 'No company name set'"
            persistent-placeholder
            :loading="gettingConfig"
            :value="config.companyName"
            @input="val => setConfig('companyName', val)"
          />

          <v-text-field
            outlined
            dense
            hide-details
            label="Approved By — Name"
            :placeholder="config.approvedByName ? '' : 'No approver name set'"
            persistent-placeholder
            :loading="gettingConfig"
            :value="config.approvedByName"
            @input="val => setConfig('approvedByName', val)"
          />

          <v-text-field
            outlined
            dense
            hide-details
            label="Approved By — Position"
            :placeholder="config.approvedByPosition ? '' : 'No approver position set'"
            persistent-placeholder
            :loading="gettingConfig"
            :value="config.approvedByPosition"
            @input="val => setConfig('approvedByPosition', val)"
          />

          <div class="flex space-x-2.5">
            <v-btn color="purple" dark :loading="gettingConfig" @click="getConfig">
              Reload
            </v-btn>
            <v-btn :loading="savingConfig" color="primary" @click="save">
              Save
            </v-btn>
          </div>
        </div>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { useWatchEffect } from '../../../../lib/utils'
import appAxios from '../../../../extra-functions/axios.extra'

const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'VAdminSettings',
  data() {
    return {
      gettingConfig: false,
      savingConfig: false,
      config: {},
      logoFile: null,
      localLogoPreview: null,
    }
  },
  computed: {
    ...mapState({
      axios: state => appAxios(state.auth.token),
    }),
    logoPreview() {
      return this.localLogoPreview || this.config.companyLogoUrl || null
    },
  },
  created() {
    this.getConfig()
  },
  destroyed() {
    clearWatchEffect()
    if (this.localLogoPreview) {
      URL.revokeObjectURL(this.localLogoPreview)
    }
  },
  methods: {
    setConfig(key, val) {
      this.config = { ...this.config, [key]: val }
    },
    onLogoChange(file) {
      if (this.localLogoPreview) {
        URL.revokeObjectURL(this.localLogoPreview)
        this.localLogoPreview = null
      }
      this.logoFile = file || null
      if (file) {
        this.localLogoPreview = URL.createObjectURL(file)
      }
    },
    getConfig() {
      watchEffect(async (onCleanup) => {
        try {
          const controller = new AbortController()
          this.gettingConfig = true
          onCleanup(() => {
            controller.abort()
          })
          const { data } = await this.axios.get('/admin-configs', {
            signal: controller.signal,
          })
          this.config = {
            companyName: data.company_name,
            companyLogoUrl: data.company_logo_url,
            approvedByName: data.approved_by_name,
            approvedByPosition: data.approved_by_position,
          }
        } catch (e) {
          console.error(e)
          this.$alertSwalError('oops something went wrong')
        } finally {
          this.gettingConfig = false
        }
      })
    },
    async save() {
      try {
        if (this.savingConfig) return
        this.savingConfig = true
        const formData = new FormData()
        formData.append('company_name', this.config.companyName || '')
        formData.append('approved_by_name', this.config.approvedByName || '')
        formData.append('approved_by_position', this.config.approvedByPosition || '')
        if (this.logoFile) {
          formData.append('company_logo', this.logoFile)
        }
        await this.axios.post('/admin-configs', formData)
        this.logoFile = null
        if (this.localLogoPreview) {
          URL.revokeObjectURL(this.localLogoPreview)
          this.localLogoPreview = null
        }
        this.$alertSwalSuccess('successfully saved company settings')
        this.getConfig()
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong')
      } finally {
        this.savingConfig = false
      }
    },
  },
}
</script>
